var React = require('react');

function Bubble (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeWidth":"2px","fill":"none","d":"M12.0212402,23.0533718 L17.6787419,19 L22,19 C26.9705627,19 31,14.9705627 31,10 C31,5.02943725 26.9705627,0.999999999 22,0.999999999 L10,0.999999999 C5.02943725,0.999999999 1,5.02943725 1,10 C1,14.9705627 5.02943725,19 10,19 L12.0212402,19 L12.0212402,23.0533718 Z"}));
}

Bubble.defaultProps = {"width":"32px","height":"25px","viewBox":"0 0 32 25","version":"1.1"};

module.exports = Bubble;

Bubble.default = Bubble;
